<template>
    <div>
        <el-dialog v-model="signInSuccessShow" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
            <div class="dialog_content">
                <div class="sign_uccess flex flexcolumn Flexalign">
                    <div class="success_text mb-10">签到成功，恭喜获得</div>
                    <el-image class="copper_coin_icon" :src="iconPath('copper_coin_icon.png')"></el-image>
                    <div class="copper_reward flex Flexalign FlexBetween">
                        <div class="flex Flexalign">
                            <div class="ml-10">铜币积分</div>
                        </div>
                        <div class="reward_result ml-15">+{{ signSuccessInfo.copperPoints }}</div>
                    </div>
                    <!-- <div class="copper_reward mt-20 flex Flexalign FlexBetween">
                        <div class="flex Flexalign">
                            <el-image class="copper_coin_icon" :src="iconPath('experience_icon.png')"></el-image>
                            <div class="ml-10">荣誉值</div>
                        </div>
                        <div class="reward_result">+{{ signSuccessInfo.honorValue }}</div>
                    </div> -->
                    <div class="btn_success mt-20 cursor_pointer" @click="closePopup">开心收下</div>
                </div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="30" color="#fff">
                        <circle-close />
                    </el-icon>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5SignInSuccess",
    props: {

    },

    data() {
        return {
            signInSuccessShow: false,
            signSuccessInfo:{
                copperPoints:50,
                honorValue:50
            }
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.signInSuccessShow = false;
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: none;
    border-radius: 10px;
    padding: 0;
    width: 814px;
    height: 838px;
    position: relative;
    background: transparent;
}

:deep(.el-dialog__header) {
    display: none;
}

.dialog_content {
    position: relative;
    z-index: 9;
    background-image: url("/public/static/img/sign_in_succes_bg.png");
    width: 814px;
    height: 838px;
    background-size: cover;
    background-repeat: no-repeat;

    .sign_uccess {
        width: 366px;
        height: 365px;
        background: linear-gradient(180deg, #FFD4D8 0%, #FFFFFF 100%);
        border-radius: 30px;
        border: 2px solid #FFFFFF;
        position: absolute;
        top: 220px;
        left: 220px;
        padding: 30px 26px;
        box-sizing: border-box;

        .success_text {
            width: 238px;
            height: 72px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #303030;
            line-height: 36px;
            text-align: center;
            font-style: normal;
            word-wrap: normal;
        }

        .copper_coin_icon {
                width: 96px;
                height: 96px;
            }

        .copper_reward {
            // width: 310px;
            // height: 62px;
            // background: rgba(255, 255, 255, 0.5);
            // border-radius: 12px;
            // border: 1px solid #FFFFFF;
            backdrop-filter: blur(1px);
            padding: 15px;
            box-sizing: border-box;
            color: #606060;

            .copper_coin_icon {
                width: 30px;
                height: 30px;
            }

            .reward_result {
                font-size: 20px;
                color: #FF4F00;
            }
        }

        .btn_success {
            width: 203px;
            height: 52px;
            background: #FF5001;
            box-shadow: 0px 6px 8px 0px rgba(255, 80, 1, 0.17);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            color: #FFFFFF;
        }
    }

    .close_icon {
        position: absolute;
        right: 180px;
        top: 190px;
    }
}
</style>